import { EventsStatsMap, EventStatsViewModel } from 'stageclip-common';

import { ById } from '../../store/normalizedState';

import * as EntityNormalizers from './entityNormalizers';

export interface NormalizedEventStatistics {
  eventStatistics: ById<EventStatsViewModel>;
}

export function normalizeEventStatistics(
  data: EventsStatsMap,
): EntityNormalizers.NormalizedEntityArray<NormalizedEventStatistics> {
  return {
    entities: {
      eventStatistics: data,
    },
    result: Object.keys(data),
  };
}
